import type { StepperProps } from './types'

import * as S from './styles'

export const Stepper = ({ steps, activeIndex }: StepperProps) => {
  return (
    <S.Container>
      {steps.map((step, index) => (
        <S.StepCell key={step}>
          <S.StepLine isActive={index === activeIndex} />
          <S.StepCircle isActive={index === activeIndex}>{step}</S.StepCircle>
        </S.StepCell>
      ))}
    </S.Container>
  )
}
